<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    :submitting="submitting"
    :submitTitle="submitTitle"
    icon="fa-money-check-edit-alt"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="stockPriceGroupForm" :labelColumnSize="3">
      <FormRow label="Name"><FormInputText placeholder="Name" v-model="stockPriceGroup.name" field="name" /></FormRow>
      <FormRow label="Linked To Stock Size"><FormCheckbox v-model="stockPriceGroup.isStockLinked" field="isStockLinked" /></FormRow>
      <FormRow label="Minimum Size Charge">
        <FormInputText v-model="stockPriceGroup.minChargeQuantity" field="minChargeQuantity" addon="m&sup2;" note="Minimum area that will be charged for glass order items" />
      </FormRow>
      <FormRow label="Minimum Price Per Item">
        <FormInputCurrency v-model="stockPriceGroup.minChargeItemPrice" field="minChargeItemPrice" note="Minimum price that will be charged to individual items" />
      </FormRow>
      <FormRow label="Minimum Price Per Group">
        <FormInputCurrency v-model="stockPriceGroup.minChargePrice" field="minChargePrice" note="Minimum price that will be charged for each group (eg, glass item plus all services)" />
      </FormRow>
      <FormRow label="Minimum Invoice Charge">
        <FormInputCurrency v-model="stockPriceGroup.minChargeInvoice" field="minChargeInvoice" note="Minimum amount that will be charged for an order/invoice containing this price group" />
      </FormRow>
      <FormHorizontalRule />
      <FormRow label="Additional Stock Description">
        <FormInputText v-model="stockPriceGroup.stockDescription" field="stockDescription" note="Additional description added to order items linked to this price group" />
      </FormRow>
      <FormRow label="Production Code">
        <FormInputText v-model="stockPriceGroup.productionCode" field="productionCode" :maxlength="1" note="Production code is displayed on the production labels associated with this pricing group" />
      </FormRow>

    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'
import { InventoryStockTypeLookup } from '@/store/types'

export default {
  name: "StockPriceGroupDialog",
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    isCreateMode: Boolean
  },
  data() {
    return {
      stockPriceGroupId: null,
      stockPriceGroup: {},
      stockPriceGroupForm: {},
      submitting: false,
      stockTypeOptions: InventoryStockTypeLookup
    }
  },
  mounted() {
  },
  computed: {
    title() {
      return this.isCreateMode ? 'New Stock Price Group' : 'Edit Stock Price Group'
    },
    submitTitle() {
      return this.isCreateMode ? 'Create' : 'Update'
    }
  },
  methods: {
    show(stockPriceGroup) {
      // Reset form
      this.stockPriceGroup = { }
      this.stockPriceGroupId = 0
      this.stockPriceGroupForm = {}
      this.submitting = false

      if(stockPriceGroup != null) {
        this.stockPriceGroup = _.cloneDeep(stockPriceGroup)
        this.stockPriceGroupId = stockPriceGroup.id
      }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var stockPriceGroupData = _.cloneDeep(this.$data.stockPriceGroup)

      if(this.isCreateMode) {
        this.$apiService.pricingService.createStockPriceGroup(stockPriceGroupData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.stockPriceGroupForm = this.processFormResponse(err)
        })
      } else {
        this.$apiService.pricingService.updateStockPriceGroup(this.stockPriceGroupId, stockPriceGroupData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.stockPriceGroupForm = this.processFormResponse(err)
        })
      }
    }
  }
}
</script>